module.exports = __webpack_public_path__ + "img/excel.37cab3b1.png";